export default __webpack_public_path__ + "static/media/training_videos.89a5a334.png";